export const environment = {
  production: true,
  enableDebug: false,
  name: 'prod',
  apiUrl: "https://api.redeployment.app/"
};
